<template>
  <div :class="`tooltip tooltip--${itemClass}`">
    <div class="tooltip__title">
      {{ $t(data.title) }}
    </div>

    <div class="tooltip__description">
      {{ $t(data.description) }}
    </div>
  </div>
</template>

<script>
import customStylesHandler from "@/mixins/customStylesHandler";

export default {

  mixins: [customStylesHandler],
  props: {
    data: {
      type: Object,
      required: true
    },

    itemClass: {
      type: String,
      default: ""
    }
  }
};
</script>
